module.exports = __webpack_public_path__ + "static/media/4.10ed0a8b.png";